module.exports = __webpack_public_path__ + "img/range2.0b7f3a77.png";